var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FullCalendar',{ref:"calendar",attrs:{"options":_vm.options},scopedSlots:_vm._u([{key:"eventContent",fn:function(ref){
var event = ref.event;
return [_c('CalendarViewEvent',{attrs:{"event-model":event}})]}},{key:"resourceLabelContent",fn:function(ref){
var resource = ref.resource;
return [_c('ContactAvatar',{staticClass:"calendar-resource",attrs:{"profile":_vm.getAvatarProfileFromResource(resource)}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }